import { calculateUnits } from "../../../common/function";
import { makePhaseWiseData } from "./utility";

export const calculateTotalUnitConsumedOfDay = (logs) => {
  if (!logs || logs.length === 0) return { totalUnitConsumed: 0, powerFactor: null };
  const sortedLogs = [...logs].sort((a, b) => (Number(a.ts) || 0) - (Number(b.ts) || 0));
  let phaseWiseData = makePhaseWiseData(sortedLogs)
  let pf = {}
  let totalUnit = {}
  for (let phase in phaseWiseData) {
    let log = phaseWiseData[phase]
    for (let i = 0; i <= log.length; i++) {
      if (log[i + 1] !== undefined) {
        let timeDiff = log[i + 1].ts - log[i].ts
        let { unitConsumed } = log[i].eu !== undefined ? { unitConsumed: log[i].eu } : calculateUnits(timeDiff, log[i].p)
        totalUnit[phase] = totalUnit[phase] || 0;
        totalUnit[phase] += unitConsumed;
        if (log[i].p !== 0) {
          pf[phase] = pf[phase] || {
            pf: 0,
            count: 0
          };
          if(log[i].pf!==undefined && log[i].pf!==null && !isNaN(log[i].pf)){
            pf[phase].pf += Math.abs(log[i].pf);
            pf[phase].count += 1;
          }
        }
      }
    }
  }
  let pfData = {}
  for (let phase in pf) {
    pfData[phase] = pf[phase].pf / pf[phase].count
  }
  const pfValues = Object.values(pfData);
  const powerFactor = pfValues.length > 0 ? pfValues.reduce((a, b) => a + b, 0) / pfValues.length : null;
  let totalUnitConsumed = Object.values(totalUnit).reduce((a, b) => a + b, 0)
  let lastLog = sortedLogs[sortedLogs.length - 1]
  return { totalUnitConsumed, powerFactor, lastLog }
}

export const findDurationCommonBetweenDGAndMixer = (mixerOccupancy,dgOccupancy) => {
    let commonDurationData = mixerOccupancy.filter(m =>
        dgOccupancy.some(d => m.st >= d.st && m.et <= d.et)
    );
    return commonDurationData;
}

export const findLatestLog = (olgLog,newlog)=>{
    if(Object.keys(olgLog).length === 0){
        return newlog;
    }
    let latestLog = olgLog;
    if(newlog.ts > latestLog.ts){
        latestLog = newlog;
    }
    return latestLog;
}

const calculateTotalUnitsUsingNetLogs = (logs) => {
  if (!logs || !logs.length) return { totalUnitConsumed: 0, powerFactor: null, lastLog: {} };

  let totalUnitConsumed = 0;
  let totalKwhForPf = 0;
  let totalVahForPf = 0;
  let lastLog = {};
  const sortedLogs = [...logs].sort((a, b) => (Number(a.ts) || 0) - (Number(b.ts) || 0));

  for (const log of sortedLogs) {
    totalUnitConsumed += log?.netkWh ?? 0;
    if (log?.netVAh > 0 && log?.netkWh > 0) {
      totalKwhForPf += log.netkWh;
      totalVahForPf += log.netVAh;
    }
    lastLog = log;
  }

  return {
    totalUnitConsumed,
    powerFactor: totalVahForPf > 0 ? totalKwhForPf / totalVahForPf : null,
    lastLog,
  };
};
  

export const resolveDeviceUnits = (deviceData) => {
  const netLogs = deviceData?.data?.netUnitLogs;
  if ((netLogs?.length ?? 0) > 0) {
    return calculateTotalUnitsUsingNetLogs(netLogs);
  }
  return calculateTotalUnitConsumedOfDay(deviceData?.data?.loadLogs ?? []);
};